import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import InitialReducer from '../slices/initial.slice';
import InitialCapsuleReducer from '../../components/pedagogy/capsules/capsules/slices/initial.slice';
import InitialCoursesUnitsReducer from '../../components/pedagogy/slices/coursesUnits.slice';

// ----------------------------------------------------------------------
export const pPersistConfig = {
  key: 'initialstates',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const initialReducer = combineReducers({
  initial: InitialReducer,
  CapsuleReducer: InitialCapsuleReducer,
  CoursesUnitsReducer: InitialCoursesUnitsReducer,

});

export default initialReducer;
